<template>
    <base-dialog :loading="loading" :value="dialog" :title="title" :persistent="!dismissible" :hide-close="!dismissible" :width="460"
        overlay-opacity="0.55" @input="dialog = $event" @close="hide">
        <slot v-if="content || $slots.content" name="content">
            <p class="confirm-text" v-html="content"></p>
        </slot>

        <template v-slot:footer>
            <div class="confirm-footer">
                <v-btn v-if="showCancel" depressed
                    class="text-none confirm-btn confirm-btn--cancel" @click.stop="hide">
                    {{ cancelLabel || $t('common.cancel') }}
                </v-btn>
                <v-btn :loading="loading" depressed
                    :color="alertMode ? 'error' : 'primary'"
                    :class="['text-none confirm-btn', { 'black--text': !alertMode }]"
                    @click.stop="onConfirm">
                    {{ confirmLabel || $t('common.confirm') }}
                </v-btn>
            </div>
        </template>
    </base-dialog>
</template>

<script>

import BaseDialog from '@/components/common/BaseDialog'

export default {
    components: { BaseDialog },
    props: {
        title: { type: String, default: '' },
        content: { type: String, default: '' },
        persistent: { type: Boolean, default: false },
        closeOnConfirm: { type: Boolean, default: true },
        closeOnCancel: { type: Boolean, default: true },
        loading: { type: Boolean, default: false },
        loadingCancel: { type: Boolean, default: false },
        cancelLabel: { type: String, default: '' },
        confirmLabel: { type: String, default: '' },
        alertMode: { type: Boolean, default: false },
        isSecondDialog: { type: Boolean, default: false },
        showCancel: { type: Boolean, default: false },
    },
    data() {
        return {
            dialog: false,
            confirmed: false
        }
    },
    computed: {
        dismissible() {
            var vm = this
            return !(vm.persistent === true) && !vm.loading
        }
    },
    methods: {
        show() {
            const vm = this
            vm.confirmed = false
            vm.dialog = true
        },
        hide() {
            this.dialog = false
        },
        onConfirm() {
            this.confirmed = true
            this.$emit('confirm')
            if (this.closeOnConfirm !== false) {
                this.hide()
            }
        }
    },
    watch: {
        dialog(newVal) {
            const vm = this
            vm.$emit('change', newVal)
            if (!newVal) {
                if (!vm.confirmed) vm.$emit('cancel')
                vm.confirmed = false
            }
        }
    }
}
</script>

<style scoped>
.confirm-text {
    font-size: 14px;
    color: var(--v-txtSecondary-base);
    line-height: 1.6;
    margin: 0;
}

.confirm-footer {
    display: flex;
}

.confirm-btn {
    flex: 1;
    height: 52px !important;
    border-radius: 0 !important;
    font-weight: 700;
}

.confirm-btn--cancel {
    flex: 0.65;
    color: var(--v-txtSecondary-base) !important;
    background: var(--v-surface2-base) !important;
}
</style>